export const STR_EMPTY = "";

export const NBSP = String.fromCharCode(160);

export function strIsNullOrEmpty(str: string | null | undefined): str is null | undefined | "" {
    return str == null || str === "";
}


// WEBPACK FOOTER //
// ./src/utils/string.ts